<template>
  <div :key="product.id">
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'product',
        ]),
    },
    async beforeRouteUpdate(to, from, next) {
        if (from.params.productId !== to.params.productId) {
            if (await this.getProductInfo(to.params.productId)) {
                next();
            }
        } else {
            next();
        }
    },
    methods: {
        ...mapActions({
            getProductInfo: 'getProductInfo',
        }),
    },
};
</script>
